import React from "react";
import { YhBox } from "@/components/YhBox";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { Description } from "@/components/YhBox/Description";
import { Button, message } from "antd";
import { useFiltrationModel } from "../../filtrationModel";
import { jsFormSender } from "@/utils/jsFormSender";
import { filtrationService } from "../../filtrationService";

export const TopButs = () => {
	const { filtrationOne } = useFiltrationModel();
	const { addNav, selectedNavId, replaceNav } = useNavModel(({ selectedNavId }) => [selectedNavId]);

	const orderStatu: IDescription[] = [
		{
			label: "标题",
			value: filtrationOne[0]?.title ?? "",
			color: DescriptionColorEnum.green,
			status: true
		},
		{
			label: "状态",
			value: "未标注",
			color: DescriptionColorEnum.green,
			status: true
		},
		{
			label: "发布时间",
			value: filtrationOne[0]?.pubTime ?? "",
			color: DescriptionColorEnum.black,
			status: true
		},
		{
			label: "首次查看时间",
			value: filtrationOne[0]?.bidEndTime ?? "",
			color: DescriptionColorEnum.black,
			status: true
		},
		{
			label: "信息来源",
			value: filtrationOne[0]?.sourceFrom ?? "",
			color: DescriptionColorEnum.black,
			status: true
		},
		{
			label: "关键词",
			value: filtrationOne[0]?.keywords ?? "",
			color: DescriptionColorEnum.black,
			status: true
		}
	];

	const transfer = (id: string) => {
		filtrationService.shift(id).then(res => {
			res && replaceNav(selectedNavId, "3-1");
			message.success("转移成功");
		})
	}


	const action = <>
		<Button
			className="mr-5"
			type="link"
			shape="round"
			onClick={() => replaceNav(selectedNavId, "2")}
		>返回</Button>
		<Button
			className="mr-5"
			type="link"
			shape="round"
			onClick={() => transfer(filtrationOne[0].id)}
		>转移</Button>
	</>

	const open = (url?: string) => {
		// url && window.open(url, '_blank'); 
		if (filtrationOne[0]?.detailLink) {
			if (filtrationOne[0].sourceFrom === "中国交建") {
				jsFormSender(filtrationOne[0]?.detailLink, {
					'condition_aid': '',
					'condition_pid': '',
					'condition_supCode': "",
					'pk_announce': filtrationOne[0]?.oid ?? '',
					'type': '',
					'setp': ''
				}, 'post', '_blank');
				return;
			}
			jsFormSender(filtrationOne[0]?.detailLink, {}, 'get', '_blank');
		}
	}

	return (
		<YhBox
			title={<>
				{orderStatu.map((item, index) => <Description key={index} {...item} />)}
				<span className="list-header-content-statu-item" style={{ display: "block" }}>
					原文链接：<span className="list-header-content-statu statu-blue" onClick={() => open(filtrationOne[0]?.detailLink)} style={{ cursor: "pointer", textDecoration: "underline" }}>
						{filtrationOne[0]?.sourceFrom === "中国石油招标投标网" ? "https://www.cnpcbidding.com" : filtrationOne[0]?.detailLink ?? ""}
					</span>
				</span>
			</>}
			style={{ paddingBottom: 0, marginBottom: "15px" }}
			action={action}
		/>
	)
}